import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';

// components
import { MyApp } from './app.component';

// native
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { Vibration } from '@ionic-native/vibration/ngx';
import { Insomnia } from '@ionic-native/insomnia/ngx';
import { InAppPurchase } from '@ionic-native/in-app-purchase/ngx';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { NativeAudio } from '@ionic-native/native-audio/ngx';

// services
import { EventsProvider } from './../providers/events/events.service';
import { JudgePowerliftingProvider } from './../providers/judge-powerlifting/judge-powerlifting.service';
import { JudgeWeightliftingProvider } from './../providers/judge-weightlifting/judge-weightlifting.service';

// Import the AF2 Module
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule, AngularFireDatabase } from '@angular/fire/database';

// AF2 Settings
export const firebaseConfig = {
  apiKey: "AIzaSyAUbuj9TonDyJZbo3Ynmf2lnasHqduNQLs",
  authDomain: "referees-1bf7e.firebaseapp.com",
  databaseURL: "https://referees-1bf7e.firebaseio.com",
  projectId: "referees-1bf7e",
  storageBucket: "referees-1bf7e.appspot.com",
  messagingSenderId: "585855905764"
};

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    IonicModule.forRoot(MyApp, {
      // statusbarPadding: false,
      mode: 'md'
    }),
    BrowserModule,
    HttpModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler
    },
    EventsProvider,
    JudgePowerliftingProvider,
    JudgeWeightliftingProvider,
    SplashScreen,
    StatusBar,
    Keyboard,
    Vibration,
    Insomnia,
    InAppPurchase,
    Clipboard,
    NativeAudio,
    AngularFireDatabase
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts